/* eslint-disable react-hooks/exhaustive-deps */
import {
  FC,
  useContext,
  useState,
  useEffect,
  useMemo,
  createContext,
} from "react";
import {
  stringifyRequestQuery,
  WithChildren,
} from "../../../../../../_metronic/helpers";
import { useAllUsers } from "./_requests";
import { useQueryRequest } from "./QueryRequestProvider";
import { UserData } from "./_models";

interface QueryResponseContextProps {
  itemsValue: number;
  startCurrentItemsValue: number;
  currentItemsValue: number;
  setCurrentItemsValue: React.Dispatch<React.SetStateAction<number>>;
  isLoading: boolean;
  query: string;
  getUsers: (params: { currentItemsValue: number; itemsValue: number }) => void;
  filters: object;
  setFilters: React.Dispatch<React.SetStateAction<object>>;
  response?: UserData[] | undefined;
  getUsersError: any;
  refetch: () => void;
}

// Создадим контекст с предоставленным интерфейсом
export const QueryResponseContext = createContext<QueryResponseContextProps>({
  itemsValue: 0,
  startCurrentItemsValue: 0,
  currentItemsValue: 0,
  setCurrentItemsValue: () => {},
  isLoading: false,
  query: "",
  getUsers: () => {},
  filters: {},
  setFilters: () => {},
  getUsersError: undefined,
  refetch: () => {},
});

const itemsValue = 100;
const startCurrentItemsValue = 0;

const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const [response, setResponse] = useState<UserData[] | undefined>(undefined);

  const [currentItemsValue, setCurrentItemsValue] = useState(
    startCurrentItemsValue
  );

  const [filters, setFilters] = useState({});

  const { state } = useQueryRequest();
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state));

  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state]);

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery);
    }
  }, [updatedQuery]);

  const {
    mutate: getUsers,
    data: usersData,
    isLoading: isGetUsersLoading,
    error: getUsersError,
  } = useAllUsers();

  useEffect(() => {
    getUsers({ currentItemsValue, itemsValue });
  }, [currentItemsValue]);

  const refetch = () => {
    getUsers({ currentItemsValue, itemsValue });
  };

  useEffect(() => {
    if (usersData) {
      setResponse(usersData);
    }
  }, [usersData]);

  return (
    <QueryResponseContext.Provider
      value={{
        itemsValue,
        startCurrentItemsValue,
        currentItemsValue,
        setCurrentItemsValue,
        isLoading: isGetUsersLoading,
        query,
        getUsers,
        filters,
        setFilters,
        response,
        getUsersError,
        refetch,
      }}
    >
      {children}
    </QueryResponseContext.Provider>
  );
};

const useQueryResponse = () => useContext(QueryResponseContext);

const useQueryResponseData = () => {
  const { response } = useQueryResponse();
  if (!response) {
    return [];
  }

  return response || [];
};

const useQueryResponseLoading = (): boolean => {
  const { isLoading } = useQueryResponse();
  return isLoading;
};

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
};
